import ListItem from '../../CarsSearch/components/SearchResult/ListItem'
import {GridCardPlaceholder} from "../GridCardPlaceholder";
import {ListCardPlaceholder} from "../ListCardPlaceholder";

export const CarList = ({
  items,
  currency,
  closeGarageModal,
  openGarageModal,
  garageModalIsOpen,
  loading,
}) => {
  if (!items && !loading) return null

  if (loading) {
    return (
      <div className="mt-4">
        {Array.from({ length: 20 }).map(() => (
          <ListCardPlaceholder />
        ))}
      </div>
    )
  }

  return (
    <ul className="list-horizontal-items cars-list-wrapper row car-list g-0 mt-3">
      {items.map((item) => (
        <ListItem
          {...item}
          key={`car-${item.id}`}
          currency={currency}
          closeGarageModal={closeGarageModal}
          openGarageModal={openGarageModal}
          modalIsOpen={garageModalIsOpen}
          withSoldMark={item.status === 'sold'}
          isPremium={item.premium}
        />
      ))}
    </ul>
  )
}
